import { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';
import fond_plan_3 from '../assets/image/mnb1.JPG';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }   
`;

const GallerySection = styled.section`
  padding: 80px 50px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  width: 100%;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const Title = styled.h2`
  text-align: center;
  color: #1d3557;
  margin-bottom: 40px;
  font-size: 2.5rem;
  animation: ${fadeIn} 1s ease-out;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ImageCard = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  height: 300px;
  animation: ${fadeIn} 1s ease-out;
  animation-delay: ${props => props.$delay}s;
  
  &:hover img {
    transform: scale(1.1);
  }

  &:hover .overlay {
    opacity: 1;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(29, 53, 87, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 20px;
  color: white;
  text-align: center;
`;

const ViewMoreButton = styled(Link)`
  display: inline-block;
  background-color: #e63946;
  color: white;
  padding: 12px 30px;
  border-radius: 5px;
  text-decoration: none;
  margin-top: 40px;
  font-weight: bold;
  transition: all 0.3s ease;
  text-align: center;
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;

  &:hover {
    background-color: #dc2f3d;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(230, 57, 70, 0.3);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  animation: ${fadeIn} 1s ease-out;
  animation-delay: 0.5s;
`;

const Gallery = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const galleryItems = [
    {
      id: 1,
      image: fond_plan_3,
      title: 'Magasin Equateur ',
      description: 'Présentation de nos derniers produits informatiques'
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978',
      title: 'Formation Entreprise',
      description: 'Session de formation sur les nouveaux équipements'
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902',
      title: 'Inauguration Nouveau Magasin',
      description: 'Ouverture de notre nouvelle succursale'
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1531973576160-7125cd663d86',
      title: 'Conférence Annuelle',
      description: 'Rencontre avec nos partenaires et clients'
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0',
      title: 'Séminaire Tech',
      description: 'Présentation des nouvelles technologies'
    },
    {
      id: 6,
      image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c',
      title: 'Lancement Produit',
      description: 'Découverte de notre nouvelle gamme'
    }
  ];

  return (
    <GallerySection id="gallery">
      <Title>Notre Galerie</Title>
      <GalleryGrid>
        {galleryItems.map((item, index) => (
          <ImageCard 
            key={item.id}
            $delay={index * 0.2}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <Image src={item.image} alt={item.title} />
            <Overlay className="overlay">
              <h3 style={{ marginBottom: '10px', fontSize: '1.5rem' }}>{item.title}</h3>
              <p>{item.description}</p>
            </Overlay>
          </ImageCard>
        ))}
      </GalleryGrid>
      <ButtonContainer>
        <ViewMoreButton to="/gallery">Voir Plus</ViewMoreButton>
      </ButtonContainer>
    </GallerySection>
  );
};

export default Gallery;